import React from 'react';

const TableHeader = (props) => {
  if (props.children.length > 0) {
    return <th className="p-3" {...props} />;
  } else {
      return <th className="border-opacity-0" />;
  }
};

export default TableHeader;
